import { EventengineStopStackTracesService_stopStackTraceServiceGetEntity } from '@festina/unitlink-general-types/unitlink/hooks/EventengineStopStackTracesService_stopStackTraceServiceGetEntity'

export const useFetchUnitlinkStackTrace =
  EventengineStopStackTracesService_stopStackTraceServiceGetEntity.useSuspenseQuery
